import { render } from "./HeroiconsOutlineExclamationCircle.vue?vue&type=template&id=28e8743a"
const script = {}

import exportComponent from "D:\\Programs\\Projects\\www\\cae-new-web\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineExclamationCircle.vue"]])

export default __exports__